import { type IconTypes } from '@procurify/ui'

import { type Enum } from '@webapp/infrastructure/types/Enum'

export const CatalogItemTagIcons = {
  CATALOG: 'catalog',
  PREVIOUS_ORDER: 'action-history',
  OVER_BUDGET: 'attention',
} as const satisfies Record<string, IconTypes>

export type CatalogItemTagIcon = Enum<typeof CatalogItemTagIcons>
